(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'header--peek');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden', 'header--peek');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'header--peek');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
(function () {

  function setVideoSource(videoEl, src) {
    if (!videoEl || !src) return;
    videoEl.pause();
    videoEl.innerHTML = '';
    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    videoEl.appendChild(source);
    videoEl.load();
  }

  function dispatchHeaderLogo(vid, index) {
    const wantsOverride = !!(vid?.swapHeaderLogo && vid?.headerLogo);

    window.dispatchEvent(new CustomEvent('scentco:headerLogoSwap', {
      detail: {
        logoUrl: wantsOverride ? vid.headerLogo : null,
        videoIndex: index
      }
    }));
  }

  function init(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.getAttribute('data-bg-type') !== 'video') return;

    const videoEl = sectionEl.querySelector('[data-hero-playlist]');
    const jsonEl = sectionEl.querySelector('[data-hero-playlist-json]');
    if (!videoEl || !jsonEl) return;

    let config;
    try {
      config = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const videos = (config.videos || []).filter(v => v?.src);
    if (!videos.length) return;

    videoEl.muted = true;
    videoEl.setAttribute('muted', '');
    videoEl.setAttribute('playsinline', '');

    const loop = !!config.loopPlaylist;
    let index = config.startIndex || 0;

    if (videoEl._playlistInit) return;
    videoEl._playlistInit = true;

    async function play(i) {
      index = i;
      const vid = videos[index];
      if (!vid) return;

      setVideoSource(videoEl, vid.src);
      dispatchHeaderLogo(vid, index);

      try { await videoEl.play(); } catch (e) {}
    }

    videoEl.addEventListener('ended', () => {
      const next = index + 1;
      if (next < videos.length) play(next);
      else if (loop) play(0);
      else {
        window.dispatchEvent(new CustomEvent('scentco:headerLogoSwap', {
          detail: { logoUrl: null }
        }));
      }
    });

    play(index);
  }

  document.querySelectorAll('[data-scentco-hero-media]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.('[data-scentco-hero-media]').forEach(init);
  });

})();

  } catch(e) { console.error(e); }
})();
})();
